import { Component, OnInit} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';


@Component({
  selector: 'app-gestion-ingreso-usuarios',
  templateUrl: './gestion-ingreso-usuarios.component.html',
  styleUrls: ['./gestion-ingreso-usuarios.component.scss']
})
export class GestionIngresoUsuariosComponent implements OnInit {  
  newForm: FormGroup;

  constructor() {
    this.newForm = this.createForm();
  }

  ngOnInit() {}

  createForm(): FormGroup {
    return new FormGroup({
      fecha_inicio: new FormControl(moment()),
      fecha_final: new FormControl(moment())
    });
  }


}
